/* @jsxImportSource react */

import type { ReactNode } from 'react';
import { cn } from '@packages/shared/src/utils/cn/cn';

interface ProductCardV2FlagsContainerProps {
  children?: ReactNode;
  className?: string;
}

export const ProductCardV2FlagsContainer = ({
  children,
  className,
}: ProductCardV2FlagsContainerProps) => (
  <div
    className={cn(
      '[grid-area:1/2/span_1/span_1]',
      'product-card-flags-container',
      'flex flex-col gap-0.5 place-self-start p-1',
      className,
    )}
  >
    {children}
  </div>
);
